export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8848.c63c7028.jpg";